import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { Text } from "../Text/Text";
import { Box } from "../Box/Box";
export var TextFieldHelp = function TextFieldHelp(_ref) {
  var children = _ref.children,
      _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError,
      other = _objectWithoutProperties(_ref, ["children", "hasError"]);

  return /*#__PURE__*/React.createElement(Box, other, /*#__PURE__*/React.createElement(Text, {
    variant: "caption",
    color: hasError ? 'alertError' : 'grey70'
  }, children));
};